import React, {Component} from "react";

import ScoutingReportsTabBase from "../../../../ui/tabs/ScoutingReportsTabBase";
import PlayerCard from "../../../../ui/tabs/scouting_reports_tab_base/PlayerCard";
import PlayerReport from "../../../../ui/tabs/scouting_reports_tab_base/PlayerReport";

class ScoutingReportsTab extends ScoutingReportsTabBase {
    renderPlayersCard = (player) => {
        return <ScoutingReportsTabBase.PlayerCard {...player}/>
    };

    renderPlayerContent = (player) => {
        return (<ScoutingReportsTabBase.PlayerReport {...player}/>);
    };

    searchableFields = (player) => {
        return [player.name, player.teamName];
    };
}

ScoutingReportsTabBase.PlayerCard = PlayerCard;
ScoutingReportsTabBase.PlayerReport = PlayerReport;

export default ScoutingReportsTab;
